import React from 'react';
import { Stack, Typography } from '@mui/material';
import type { ArbitraryTypedObject, PortableTextBlock, TypedObject } from '@portabletext/types';
import { SanityBody } from '@shared/components';

interface Props<B extends TypedObject = PortableTextBlock | ArbitraryTypedObject> {
  title: string;
  content: B[];
}

export const HelpArticle: React.FC<Props> = ({ title, content }) => {
  return (
    <Stack py={2} px={4}>
      <Typography variant="h4" component="h2" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <SanityBody body={content} />
    </Stack>
  );
};
